import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Breadcrumb } from '@/components/base/Breadcrumb';

export default function About() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料曝光',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '真实内幕全收录，助你看清真相、辨别是非，拒绝虚假信息。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@heiliaobaoguang.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料曝光的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容来源包括记者调查、业内人士爆料、公开信息整理以及用户投稿。所有曝光内容均经过编辑团队的多方核实，确保信息真实可靠。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向黑料曝光投稿爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过页面底部的联系方式发送邮件至 baoliao@heiliaobaoguang.com 进行投稿。我们会对所有投稿信息进行严格保密，保护爆料人的隐私安全。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料曝光的内容是否可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们坚持\"经过核实的黑料曝光\"原则，所有发布的内容都经过编辑团队的多方核实和证据审核。对于尚未完全核实的信息，我们会明确标注\"待核实\"。',
        },
      },
      {
        '@type': 'Question',
        name: '如果发现内容不实怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '如果您认为我们的内容存在不实之处，请通过邮箱 shensu@heiliaobaoguang.com 联系我们，提供相关证明材料。我们将在核实后第一时间做出处理，包括更正或删除。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们"
        description="黑料曝光品牌介绍 - 真实内幕全收录。了解我们的使命、团队和联系方式，助你看清真相、辨别是非。"
        keywords="黑料曝光,关于我们,品牌介绍,联系方式,投稿爆料"
        schema={[orgSchema, faqSchema]}
      />
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-6 md:px-8 py-8 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mt-4" style={{ fontFamily: 'var(--font-heading)' }}>
              关于我们
            </h1>
            <p className="text-foreground-500 mt-2">真实内幕全收录，助你看清真相、辨别是非</p>
          </div>
        </div>

        <section className="w-full px-6 md:px-8 py-14">
          <div className="max-w-4xl mx-auto">
            <div className="aspect-[21/9] rounded-xl overflow-hidden mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20editorial%20newsroom%20with%20soft%20cinematic%20lighting%2C%20vintage%20journalism%20aesthetic%2C%20wooden%20desk%20with%20typewriter%20and%20scattered%20newspapers%2C%20cozy%20atmosphere%2C%20golden%20hour%20tones%2C%20minimal%20composition&width=1600&height=600&seq=about-hero&orientation=landscape"
                alt="黑料曝光编辑部"
                className="w-full h-full object-cover"
              />
            </div>

            <h2 className="text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              品牌使命
            </h2>
            <p className="text-base leading-relaxed text-foreground-700 mb-8">
              在这个信息爆炸的时代，真假难辨的资讯充斥着我们的生活。黑料曝光应运而生——我们致力于汇聚娱乐圈、商业圈、网红博主等各领域的真实内幕信息，经过多方核实和严谨审核后呈现给读者，帮助每一位关注者看清事实真相、辨别虚假信息。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-12">
              {[
                { icon: 'ri-shield-check-line', title: '真实可靠', desc: '所有曝光内容均经过多方核实，拒绝虚假信息和恶意造谣' },
                { icon: 'ri-timer-flash-line', title: '快速及时', desc: '第一时间追踪热点事件，让您不错过任何重要内幕曝光' },
                { icon: 'ri-user-heart-line', title: '用户至上', desc: '严格保护爆料人隐私安全，尊重每一位读者和投稿人' },
              ].map((item) => (
                <div key={item.title} className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-base font-bold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>

            <h2 className="text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
              {[
                { name: '李先生', text: '关注黑料曝光半年了，内容质量确实高。不像其他自媒体那样乱编故事，每篇都有据可查。很喜欢他们的调查报道。', role: '资深媒体从业者' },
                { name: '王女士', text: '以前总觉得网上到处都是谣言，不知道该信谁。黑料曝光帮我省了很多辨别真假的时间，现在只在这里看内幕新闻。', role: '互联网企业高管' },
                { name: '张同学', text: '作为一个追星族，黑料曝光让我看到了娱乐圈的另一面。不是无脑黑，而是有理有据的曝光，让我对很多事有了新的认识。', role: '在校大学生' },
                { name: '赵律师', text: '从法律从业者的角度看，黑料曝光的内容严谨度令人印象深刻。他们对证据的重视程度远超一般自媒体，这在行业内非常难得。', role: '执业律师' },
              ].map((item) => (
                <div key={item.name} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <p className="text-sm text-foreground-600 italic leading-relaxed">"{item.text}"</p>
                  <div className="flex items-center gap-2 mt-3 pt-3 border-t border-background-200/70">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 text-xs font-bold">
                      {item.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-bold text-foreground-950">{item.name}</p>
                      <p className="text-xs text-foreground-400">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <h2 className="text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12">
              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mx-auto mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-950 mb-1">投稿爆料</h3>
                <p className="text-xs text-foreground-400">baoliao@heiliaobaoguang.com</p>
              </div>
              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 mx-auto mb-3">
                  <i className="ri-chat-1-line text-lg"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-950 mb-1">内容申诉</h3>
                <p className="text-xs text-foreground-400">shensu@heiliaobaoguang.com</p>
              </div>
              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500 mx-auto mb-3">
                  <i className="ri-briefcase-line text-lg"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-950 mb-1">商业合作</h3>
                <p className="text-xs text-foreground-400">hezuo@heiliaobaoguang.com</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}